import Vue from 'vue'
import formatDate from '../helpers/formatDate'

Vue.filter('formatDate', function (value, iso) {
  return formatDate(value, iso)
})
